import React from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  DisplayStar,
  HalfDisplayStar,
  ReviewCount,
} from './StarRating.style';

const TOTAL_STARS = 5;

const StarRating = ({
  rating,
  totalReviews,
  size,
  sizeDesktop,
  fontSize,
  fontSizeDesktop,
  marginTop,
  reviewFontSize,
  gap,
}) => {
  const clampedRating = Math.min(Math.max(rating || 0, 0), TOTAL_STARS);
  const fullStars = Math.floor(clampedRating);
  const hasHalf = clampedRating % 1 >= 0.5;
  const emptyStars = TOTAL_STARS - fullStars - (hasHalf ? 1 : 0);

  const starProps = {
    $size: size,
    $sizeDesktop: sizeDesktop,
    $fontSize: fontSize,
    $fontSizeDesktop: fontSizeDesktop,
    $marginTop: marginTop,
    $reviewFontSize: reviewFontSize,
    $gap: gap,
  };

  return (
    <Wrapper>
      {Array.from({length: fullStars}, (_, i) => (
        <DisplayStar key={`full-${i}`} $rated={true} {...starProps} />
      ))}
      {hasHalf && <HalfDisplayStar key="half" {...starProps} />}
      {Array.from({length: emptyStars}, (_, i) => (
        <DisplayStar key={`empty-${i}`} $rated={false} {...starProps} />
      ))}
      {totalReviews != null && (
        <ReviewCount {...starProps}>({totalReviews})</ReviewCount>
      )}
    </Wrapper>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  totalReviews: PropTypes.number,
  size: PropTypes.string,
  sizeDesktop: PropTypes.string,
  fontSize: PropTypes.string,
  fontSizeDesktop: PropTypes.string,
};

export default StarRating;
